/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Get_AppInputs */



/**
* | output |
* | --- |
* | "Get the app" |
*
* @param {Nav_Get_AppInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_get_app = /** @type {((inputs?: Nav_Get_AppInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Get_AppInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("App holen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Obtenir l'app")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("获取 App")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("取得 App")
	if (locale === "ko") return /** @type {LocalizedString} */ ("앱 받기")
	return /** @type {LocalizedString} */ ("Get the app")
});